import axios from "axios";
import { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../workers/WorkerCategories.css"
import editIcon from "../../../assets/img/small-logos/edit_icon.svg"
import deleteIcon from "../../../assets/img/small-logos/delete _icon.svg";
import Swal from "sweetalert2";
import eye from "../../../assets/img/icons/eye-solid.svg"
import profileIcon from "../../../assets/img/icons/vecteezy_man-empty-avatar-vector-photo-placeholder-for-social_36594092.jpg"
import "./Workers.css";
import LoadingGif from "src/components/layout/Loader";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { IWorker } from "src/helper/interfaces";
import Cookies from "js-cookie";
import { formatCategory, formatDiffrentDate, getSpecializations } from "src/utils/normalFuntions";
import Paginator from "src/components/layout/Paginator";
import { TreeNode } from 'primereact/treenode';
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import ExportDocs from "src/components/layout/ExportDocs";
import { Link } from "react-router-dom";
import CheckboxFilter from "src/components/layout/CheckboxFilter";


const getAllWorkers = async (
   token: string,
   pageNumber: number,
   searchValue: string,
   pageSize: number,
   startDate?: string,
   endDate?: string,
   membership?: boolean,
   subscription?: boolean,
   subCategories?: string[],
   service?: string[],
   activeWorkers?: string[]
) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/all-workers`, {
      headers: {
         "x-access-token": token
      },
      params: {
         page: pageNumber,
         search_value: searchValue,
         pageSize,
         start_date: startDate,
         end_date: endDate,
         membership,
         subscription,
         category: subCategories,
         services: service,
         is_active: activeWorkers
      }

   })
};

export const getSubCatByCatId = async (token: string, categoryName: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/subCat-by-catId`, {
      headers: {
         "x-access-token": token
      },
      params: {
         category_name: categoryName,
         pageSize: 50
      }
   })
}

export const getAllCategories = async (token: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/categories`, {
      headers: {
         "x-access-token": token
      }
   })

};
interface IRatingtypes {
   token: string;
   id: string;
   pageNo?: number;
   pageSize?: number;
   type: string;
}
export const getWorkerRatings = async (params: IRatingtypes) => {
   const { token, id, pageNo, pageSize, type } = params;
   return await axios.get(`${AppConfig?.DEV_SERVER}/worker/rating-history/${id}`, {
      headers: {
         "x-access-token": token
      },
      params: {
         page: pageNo,
         pageSize,
         type

      }
   })
}

export type sidePages = {
   workerDetails: boolean,
   transactions: boolean,
   earnings: boolean,
   leads: boolean,
   ratings: boolean
}
const Workers = () => {

   // const initialValues: InitialValuesType = {
   //    _id: "",
   //    phone: "",
   //    has_membership: false,
   //    has_subscription: false,
   //    is_activated_account: false,
   //    is_basic_details_completed: false,
   //    is_document_details_completed: false,
   //    is_membership_details_completed: false,
   //    is_online: false,
   //    is_otp_verified: false,
   //    is_question_ans_completed: false,
   //    is_verified: false,
   //    specification: [],
   //    you_are_a: [],
   //    your_work: [],
   //    country: "",
   //    state: "",
   //    city: "",
   //    dial_code: "",
   //    lat: 0.0,
   //    long: 0.0,
   //    otp: "",
   //    pin_code: "",
   //    street: "",
   //    landmark: "",
   //    alternate_number: "",
   //    bio: "",
   //    date_of_birth: "",
   //    gender: "Other",
   //    name: "",
   //    account_holder_name: "",
   //    bank_name: "",
   //    account_number: "",
   //    IFSC_code: "",
   //    profile_pic: null,
   //    qualification: "",
   //    referral_code: "",
   //    my_referral: "",
   //    createdAt: "",
   //    sub_worker_type: [],
   //    worker_type: "",
   //    worker_specialization: [],
   //    adhaar_number: "",
   //    pan_number: "",
   //    adhaar_front_pic: "",
   //    adhaar_back_pic: "",
   //    category: "",
   //    firm_age: "",
   //    firm_gst_number: "",
   //    firm_pan_number: "",
   //    firm_gst_pic: "",
   //    firm_pan_pic: "",
   //    seller_shop_pic1: "",
   //    seller_shop_pic2: "",
   //    pan_front_pic: "",
   //    more_areas_served: "",
   //    firm_name: "",
   //    walletAmount: 0

   // };

   const dispatch = useAppDispatch();
   // const { isBackClicked } = useBackContext();

   const [workers, setWorkers] = useState<IWorker[]>([])
   const [searchVal, setSearchVal] = useState("");
   const [pageNo, setPageNo] = useState(1);
   const [pageSize, setPageSize] = useState(20);
   const [totalPages, setTotalPages] = useState(0);

   const loading = useAppSelector(state => state.loading.value);
   const Token = Cookies.get("token");
   const [startDate, setStartDate] = useState<Date | undefined>(undefined);
   const [endDate, setEndDate] = useState<Date | undefined>(undefined);
   const startingDate = startDate ? startDate.toISOString() : undefined;
   const endingDate = endDate ? endDate.toISOString() : undefined;
   const [selectedSubCats, setSelectedSubCats] = useState<string[]>([]); // Tracks selected child nodes
   const [selectedServices, setSelectedServices] = useState<string[]>([]);
   const [activeWorkers, setActiveWorkers] = useState<string[]>([]);

   useEffect(() => {
      dispatch(startLoading());
      getAllWorkers(
         Token as string, pageNo, searchVal, pageSize,
         startingDate, endingDate,
         selectedServices.includes("Membership"), // Membership boolean
         selectedServices.includes("Subscription"), // Subscription boolean
         selectedSubCats, selectedServices,
         activeWorkers
      ).then((res) => {
         // console.log(res)
         if (res?.data?.status_code === 200) {
            setWorkers(res?.data?.data?.data);
            setTotalPages(res?.data?.data?.totalPages);
            dispatch(stopLoading());

         }
      }).catch((err) => {
         console.log(err);
         throw err;
      })
   }, [
      Token,
      pageNo, searchVal, pageSize,
      startDate, endDate,
      selectedSubCats, selectedServices,
      activeWorkers
   ]);



   const handleDeleteConfirmed = (id: string) => {
      // console.log(id);
      if (Token === undefined) {
         console.error("Token is undefined");
         return;
      }
      // Dispatch the delete action here
      Swal.fire({
         title: 'Are you sure?',
         text: "You cant't revert this!",
         icon: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'Yes, delete worker!'
      }).then(async (response) => {
         if (response.isConfirmed) {
            // console.log("lamao")
            await axios({
               url: `${AppConfig.DEV_SERVER}/worker/${id}`,
               method: "DELETE",
               headers: {
                  'content-type': 'multipart/form-data',
                  "x-access-token": Token,
               }
            }).then((res) => {
               // console.log(res)
               Swal.fire(
                  'Deleted!',
                  `${res?.data?.msg}`,
                  'success'
               ).then(() => {
                  getAllWorkers(Token as string, pageNo, searchVal, pageSize, startingDate, endingDate).then((res) => {
                     // console.log(res)
                     if (res?.data?.status_code === 200) {
                        setWorkers(res?.data?.data?.data);
                        setTotalPages(res?.data?.data?.totalPages)
                     } else {
                        Swal.fire({
                           icon: "error",
                           title: "Oops...",
                           text: `${res?.data?.data?.msg}`,
                           footer: '<a href="#">Why do I have this issue?</a>'
                        });
                     }
                  })
               })

            }).catch((err) => {
               console.log(err)
            })  // Clear the selectedFoodItem state after updating
            // setModalShow(false);
         }
      }
      )
   };

   const handleSelectionChange = (selectedChildren: TreeNode[]) => {
      // console.log("Selected Children in Worker:", selectedChildren);
      const serviceArray: string[] = [];
      const subCatArray: string[] | undefined = [];
      const activeWorkersArray: string[] = [];
      selectedChildren.map((data: TreeNode) => {
         if (data.label === "Membership" || data?.label === "Subscription") {
            serviceArray.push(data?.label); // Keep track of service types
         }
         else if (data.label === "Active" || data?.label === "Inactive") {
            activeWorkersArray.push(data?.label); // Track active worker status
         }
         else {
            subCatArray.push(data?.label as string); // Track active worker status
         }
      });
      setSelectedServices(serviceArray);
      setSelectedSubCats(subCatArray);
      setActiveWorkers(activeWorkersArray)
      // Process the selected children here
   };

   const clearSearchValue = () => {
      setSearchVal("");  // Clear the search input
   };


   const doc = new jsPDF();
   doc.text("Worker Report", 14, 10);

   const formattedData = workers.map((item: IWorker, i) => {
      const address = `${item?.address?.street || ''}, ${item?.address?.city || ''}, ${item?.address?.state || ''}, ${item?.address?.country || ''} - ${item?.address?.pin_code || ''}`;

      const bankDetails = `${item?.bank_details?.account_holder_name || ''},${item?.bank_details?.account_number || ''}, ${item?.bank_details?.bank_name || ''}, ${item?.bank_details?.IFSC_code || ''}`;

      const specifications = item?.specification?.join(", ") || "N/A";

      return {
         _id: item?._id,
         name: item?.name,
         date_of_birth: item?.date_of_birth || "N/A",
         gender: item?.gender || "N/A",
         phone: item?.phone,
         alternate_number: item?.alternate_number || "N/A",
         dial_code: item?.dial_code || "N/A",
         is_verified: item?.is_verified ? "Yes" : "No",
         qualification: item?.qualification || "N/A",
         specification: item?.specification?.length ? specifications : "NA",
         bank_details: item?.bank_details ? bankDetails : "NA",
         razorpay_contact_id: item?.razorpay_contact_id || "N/A",
         // razorpay_fund_id: item?.razorpay_fund_id || "N/A",
         referral_code: item?.referral_code || "N/A",
         has_membership: item?.has_membership ? "Yes" : "No",
         has_subscription: item?.has_subscription ? "Yes" : "No",
         is_online: item?.is_online ? "Online" : "Offline",
         address: item?.address ? address : "NA",
         date: new Date(item.createdAt).toLocaleDateString(),
      };
   });

   const headers = [
      { label: "Worker Id", key: "_id" },
      { label: "Name", key: "name" },
      { label: "Date of Birth", key: "date_of_birth" },
      { label: "Gender", key: "gender" },
      { label: "Phone", key: "phone" },
      { label: "Alternate Number", key: "alternate_number" },
      { label: "Dial Code", key: "dial_code" },
      { label: "Verified", key: "is_verified" },
      { label: "Qualification", key: "qualification" },
      { label: "Specifications", key: "specification" },
      { label: "Bank Details", key: "bank_details" },
      { label: "Razorpay Contact ID", key: "razorpay_contact_id" },
      { label: "Razorpay Fund ID", key: "razorpay_fund_id" },
      { label: "Referral Code", key: "referral_code" },
      { label: "Membership", key: "has_membership" },
      { label: "Subscription", key: "has_subscription" },
      { label: "Online Status", key: "is_online" },
      { label: "Address", key: "address" },
      { label: "Date", key: "date" }
   ];

   const exportPDF = () => {
      const doc = new jsPDF();

      // Define the columns for the table
      const tableColumns = [
         "Worker Id", "Name", "Date of Birth", "Gender", "Phone", "Alternate Number", "Dial Code", "Verified",
         "Qualification", "Specifications", "Bank Details", "Razorpay Contact ID", "Razorpay Fund ID",
         "Referral Code", "Membership", "Subscription", "Online Status", "Address", "Date"
      ];

      const tableData = formattedData.map(item => [

         item._id || '',
         item.name || '',
         item.date_of_birth || '',
         item.gender || '',
         item.phone || '',
         item.alternate_number || '',
         item.dial_code || '',
         item.is_verified || '',
         item.qualification || '',
         item.specification || '',
         item.bank_details || '',
         item.razorpay_contact_id || '',
         // item.razorpay_fund_id || '',
         item.referral_code || '',
         item.has_membership || '',
         item.has_subscription || '',
         item.is_online || '',
         item.address || '',
         item.date || ''
      ]);

      // Use autoTable to generate the table
      autoTable(doc, {
         head: [tableColumns],
         body: tableData,
         headStyles: { fillColor: [255, 0, 0], textColor: [255, 255, 255], fontSize: 12, fontStyle: 'bold' },
         bodyStyles: { fontSize: 10 },
         columnStyles: { 0: { cellWidth: 30 }, 1: { cellWidth: 'auto' } },
      });


      // Save the generated PDF
      doc.save('worker_report.pdf');
   };




   const handlePageSizeChange = (e: any) => {
      setPageSize(e.target.value);
   };
   return (
      <MainLayout
         showAllFilters={false}
         searchValue={searchVal}
         onChange={(e) => setSearchVal(e.target.value)}
         clearValChange={clearSearchValue}
         startDate={startDate}
         endDate={endDate}
         startDateOnChange={(e) => setStartDate(e)}
         endDateOnChange={(e) => setEndDate(e)}
         // onSelectionChange={handleSelectionChange}
         pageSize={pageSize}
         // isOpen={showSideBar}
      >

         <div className="main-div">

            <div className={`category-main me-2 card p-md-4`} >
               {
                  loading ?
                     <div>
                        <LoadingGif />
                     </div>

                     : ""
               }
               <div>
                  <div className="d-flex justify-content-end mb-3 gap-4 flex-wrap">
                     <CheckboxFilter onSelectionChange={handleSelectionChange} />
                     <div className="d-flex gap-2">
                        <span className="d-flex align-items-center pagesize-text">
                           PageSize
                        </span>

                        <select
                           className="form-select"
                           style={{ backgroundPosition: "right 5px center", width: "60px" }}
                           aria-label="Default select example"
                           value={pageSize} // Bind the value to the state
                           onChange={handlePageSizeChange} // Handle the change
                        >
                           <option value={20}>20</option>
                           <option value={50}>50</option>
                           <option value={100}>100</option>
                           <option value={200}>200</option>
                        </select>
                     </div>

                     <ExportDocs headers={headers} formattedData={formattedData} clickHandler={exportPDF} />

                  </div>
                  <div className="table-responsive">
                     <table className="table table-striped card-body">
                        <thead>
                           <tr className="category-tr">
                              <th scope="col" className="text-start ps-4">Sr.No.</th>
                              <th scope="col" className="text-start ps-4">Profile Pic</th>
                              <th scope="col" className="text-start ps-4">Name</th>
                              <th scope="col" className="text-start ps-4">Phone No.</th>
                              <th scope="col" className="text-start ps-4">Worker Type</th>
                              <th scope="col" className="text-start ps-4">Specification</th>
                              <th scope="col" className="text-start ps-4">Membership</th>
                              <th scope="col" className="text-start ps-4">Subscription</th>
                              <th scope="col" className="text-start ps-4">Wallet</th>
                              <th scope="col" className="text-start ps-4">Joined At</th>

                              <th scope="col" className="col-lg-2 ps-4 ">Action</th>
                           </tr>
                        </thead>
                        <tbody>
                           {
                              workers && workers?.map((data: IWorker, i) => {

                                 // const joinDate = moment(data?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY');
                                 const joinDate = formatDiffrentDate(data?.createdAt);
                                 const rowNumber = (pageNo - 1) * pageSize + (i + 1);
                                 return (
                                    <tr key={data?._id}>
                                       <td className="text-start align-content-center ps-4">
                                          <span className="">
                                             {rowNumber}
                                          </span>

                                       </td>
                                       <td className="text-start align-content-center">
                                          {data?.profile_pic ?
                                             <img src={data?.profile_pic as string} alt="profile-pic" className="profile-pic" />
                                             :
                                             <span className="d-flex align-items-center ">
                                                <img src={profileIcon} alt="profileIcon" className="profile-pic" />
                                             </span>}
                                       </td>

                                       <td className="text-start align-content-center ps-4">
                                          <span className="">
                                             {data?.name || "NA"}
                                          </span>

                                       </td>

                                       <td className="text-start align-content-center ps-4 ">
                                          <span className=" align-items-center">
                                             {data?.phone || "NA"}
                                          </span>
                                       </td>

                                       <td className="text-start align-content-center ps-4 ">
                                          <span className=" align-items-center">

                                             {formatCategory(data?.worker_type) || "NA"}
                                          </span>
                                       </td>
                                       <td className="text-start align-content-center ps-4 ">
                                          <span className=" align-items-center">
                                             {getSpecializations(data) || "NA"}

                                          </span>
                                       </td>

                                       <td className="icon-td align-content-center text-start ps-4">
                                          {data?.has_membership ? "Active" : "Inactive"}
                                       </td>
                                       <td className="icon-td align-content-center text-start ps-4">
                                          {data?.has_subscription ? "Active" : "Inactive"}
                                       </td>
                                       <td className="icon-td align-content-center text-start ps-4">
                                          {data?.walletAmount?.toFixed(2) || 0}
                                       </td>
                                       <td className="icon-td align-content-center text-start ps-4" width={"160px"}>
                                          {joinDate?.formattedDate}, <br />{joinDate?.formattedHours}
                                       </td>
                                       <td className="align-content-center ">
                                          <div className="d-flex justify-content-center gap-3 ">

                                             <Link to={data?.has_membership ? `/workers/edit/${data?._id}` : "#"} style={{ pointerEvents: data?.has_membership ? "auto" : "none" }}>
                                                <button
                                                   className="btn btn-sm edit_btn"
                                                   style={{
                                                      marginBottom: "1px",
                                                      backgroundColor: data?.has_membership ? "" : "#C3C3C3",
                                                      cursor: data?.has_membership ? "pointer" : "not-allowed"
                                                   }}
                                                   disabled={!data?.has_membership}
                                                >
                                                   <img src={editIcon} />
                                                </button>
                                             </Link>

                                             <Link to={`/workers/${data?._id}`}>

                                                <button className="btn btn-sm delete_btn ">
                                                   <img src={eye} />
                                                </button>
                                             </Link>
                                             <button className="btn btn-sm delete_btn " onClick={() => handleDeleteConfirmed(data?._id)}>
                                                <img src={deleteIcon} />
                                             </button>

                                          </div>

                                       </td>
                                    </tr>
                                 )
                              }
                              )
                           }

                        </tbody>
                     </table>
                  </div>


                  <Paginator
                     totalPages={totalPages}
                     pageNo={pageNo}
                     onPageChange={(e, no) => setPageNo(no)}
                     alignment="right"
                  />
               </div>


            </div>

         </div>

      </MainLayout >
   )

};



export default Workers;